import { E_XYGT_TagName } from "@/custom/sensor"
import { E_AlarmType } from "../enums"
import { E_YesNoNumber, ICoordinate, IPageData, IPageParams } from "../types"
import { E_ChannelType, E_CollectCardType } from "./collectCard.types"
import { IFaultSetting } from "./fault.types"
import { IFileListItem } from "./file.types"
import { E_Axis, E_CollectMode, E_CollectWork, E_InstallMethod, E_MHFFlag, E_SensorDirection, E_SensorKlass, E_SensorOpenWave, E_SensorType, E_StartStatus } from "./sensor.types"
import { E_UseLearn } from "./sensorLearn.types"
import { E_OnlineOffline } from "./overview.types"
import { E_InspectStatus } from "@/spot_check/api/modules/inspection/inspection_task.types"
import { E_ImportStatus } from "./equipment.types"
import { E_FaultStatus } from "./sensorThreshold.types"
import { E_OfflineDataStatus } from "./gateway.types"
import { E_FirewareUpgradeStatus } from "./firmware.types"

/**
 * JJ调试
 */
export enum E_JJDebug {
    /**
     * 开启
     */
    Open = 1,
    /**
     * 关闭
     */
    Close = 2,
}

/**
 * 同步采集
 * $t('enum.E_SyncCollectStatus.Close')
 * $t('enum.E_SyncCollectStatus.Open')
 */
export enum E_SyncCollectStatus {
    /**
     * 关闭
     */
    Close = 0,
    /**
     * 开启
     */
    Open = 1
}


/**
 * 网关id锁定
 */
export enum E_GatewaySnLock {
    /**
     * 锁定
     */
    Locked = '1',
    /**
     * 未锁定
     */
    Unlocked = '0'
}


/**
 * $t('enum.E_CoefType.MidFreq')
 * $t('enum.E_CoefType.HighFreq')
 */
export enum E_CoefType {
    /**
     * 中频
     */
    MidFreq = 1,
    /**
     * 高频
     */
    HighFreq = 2,
}

/**
 * $t('enum.E_DriveType.DrivePort')
 * $t('enum.E_DriveType.NonDrivePort')
 */
export enum E_DriveType {
    /**
     * 驱动端
     */
    DrivePort = 1,
    /**
     * 非驱动端
     */
    NonDrivePort = 2,
}

/**
 * $t('enum.E_SensorDownloadStatus.Pending')
 * $t('enum.E_SensorDownloadStatus.HasSending')
 * $t('enum.E_SensorDownloadStatus.Modified')
 */
export enum E_SensorDownloadStatus {
    /**
     * 待下发
     */
    Pending = 0,
    /**
     * 已下发
     */
    HasSending = 1,
    /**
     * 已修改
     */
    Modified = 2,
}

/**
 * 通信选择
 * $t('enum.E_CommChoice.Gateway')
 * $t('enum.E_CommChoice.CollectCard')
 * $t('enum.E_CommChoice.Direct')
 */
export enum E_CommChoice {
    /**
     * 网关
     */
    Gateway = 1,
    /**
     * 采集卡
     */
    CollectCard = 2,
    /**
     * 直连
     */
    Direct = 3,
}

/*
 * 载波反转
 * $t('enum.E_CarrierReversal.NotReversal')
 * $t('enum.E_CarrierReversal.Reversal')
 */
export enum E_CarrierReversal {
    /**
     * 载波不反转
     */
    NotReversal = 0,
    /**
     * 载波反转
     */
    Reversal = 1,
}

/**
 * 下发状态
 * $t('enum.E_SendWaveStatus.Pending')
 * $t('enum.E_SendWaveStatus.HasSend')
 * $t('enum.E_SendWaveStatus.HasModified')
 * $t('enum.E_SendWaveStatus.Failed')
 */
export enum E_SendWaveStatus {
    /**
     * 待下发
     */
    Pending = 1,
    /**
     * 已下发
     */
    HasSend = 2,
    /**
     * 已修改
     */
    HasModified = 3,
    /**
     * 失败
     */
    Failed = 4,
}


/**
 * 转标准协议
 * $t('enum.E_ConvertProtocolType.ModbusTcp')
 */
export enum E_ConvertProtocolType {
    ModbusTcp = 1,
}

/**
 * 传感器绑定状态
 * $t('enum.E_UnbindSensorStatus.Binded')
 * $t('enum.E_UnbindSensorStatus.NoBinded')
 */
export enum E_UnbindSensorStatus {
    /**
     * 已绑定
     */
    Binded = 1,
    /**
     * 未绑定
     */
    NoBinded = 2,
}

export enum E_SelectedStatus {
    /**
     * 选中
     */
    Selected = 1,
    /**
     * 未选中
     */
    NotSelected = 2,
}

export enum E_SensorSettingType {
    /** 
     * 远程重启
    */
    RemoteRestart = 16,
    /** 
     * 恢复出厂设置
    */
    ResetFactorySetting = 17,
}

/**
 * 校准系数是否有效 * 
 */
export enum E_CompensateStatus {
    /**
     * 无效
     */
    NotValid = 0,
    /**
     * 有效
     */
    Valid = 1,
}

/**
* 采集模式
* $t('enum.E_DataSamplingMode.RegularTime')
* $t('enum.E_DataSamplingMode.Quantitative')
 */
export enum E_DataSamplingMode {
    /**
     * 定时采集
     */
    RegularTime = 0,
    /**
     * 定量采集
     */
    Quantitative = 1,
}

/**
 * 通信协议类型
 * $t('enum.E_CommunicationProtocolType.TCP')
 * $t('enum.E_CommunicationProtocolType.MQTT')
 */
export enum E_CommunicationProtocolType {
    TCP = 0,
    MQTT = 1,
}

/**
 * 波形压缩功能开关
 * $t('enum.E_WaveCompressFlag.Open')
 * $t('enum.E_WaveCompressFlag.Close')
 */
export enum E_WaveCompressFlag {
    Open = 1,
    Close = 0,
}

/**
 * 协议版本
 * $t('enum.E_ProtocolVersion.Original')
 * $t('enum.E_ProtocolVersion.Universal')
 */
export enum E_ProtocolVersion {
    Original = 0,
    Universal = 1,
}


export interface ISensorDebug {

    /**
     * 电流量程
     */
    elecRange: number

    /**
     * 交流三相电流系数:X1,X0,B
     */
    elecCompensate: string

    /**
     * 加速度校准系数: X3,X2,X1,B
     */
    accCompensate: string

    /**
     * 加速度校准系数开关
     */
    accCompensateStatus: E_CompensateStatus

    /**
     * 高频波形补偿系数: X3,X2,X1,B
     */
    accHighCompensate: string

    /**
     * 高频加速度校准系数开关
     */
    accHighCompensateStatus: E_CompensateStatus

    /**
     * 
     */
    ahighMax: number
    /**
     * 3轴包络阈值上限：x,y,z
     */
    envelopeMax: string
    /**
     * 3轴包络阈值下限：x,y,z
     */
    envelopeMin: string

    /** 3轴振动烈度上限：x,y,z */
    vibraMax: string

    /** 波形采集加速度阈值下限 */
    waveAccMin: number

    /** 高频灵敏度校准系数 */
    sensitivityHighCompensate: string

    /** 蓝牙名称 */
    bluetoothName: string
    /**
     * 网关id
     */
    gatewaySn: string
    /**
     * 网关id锁定
     */
    gatewaySnLock: E_GatewaySnLock    

    /**
     * 广域网络ID
     */
    wanId: number

    /** 离线数据保存状态 */
    offlineDataStatus: E_OfflineDataStatus

    /** 射频通道 */
    wirelessChannel: number
}

export interface IPointMapping {
    areaId: number
    companyId: number
    driveType: E_DriveType
    equipmentId: number
    extendId: number
    gearId: number
    gearName?: string
    location: string
    pointName: string
    sort: number
}

export interface ISensorSetListItem {
    /**
     * 轴向:X, Y, Z, XYZ',
     */
    axis: E_Axis
    /**
     * 中频，高频标志位
     */
    mhfFlag?: E_MHFFlag
    /**
     * 采样频率
     */
    mhfHz?: string
    /**
     * 
     */
    mhfUse: E_YesNoNumber

    /**
     * 传感器灵敏度
     */
    sensorSensitivity: number
    /**
     * 偏置电压
     */
    voltage: number
    /**
     * 采集间隔
     */
    samplingInterval: number
    /**
     * 传感器编号
     */
    sensorId: number
    /**
     * 点数
     */
    wavePoint: number

    /**
     * 采集时长
     */
    collDuration?: number
}

export interface ISensorInfo extends ISensorInfoBase {
    /**
     * 配置命令创建时间
     */
    sendSettingTime: string

    /**
     * 最近一次配置命令下发时间，未下发时为空
     */
    sendTime?: string

    /**
     * 配置命令处理完成时间，成功或失败时记录
     */
    completeTime?: string

    /**
     * 阈值名称
     */
    alarmThresholdName: string
    /**
     * 网关名称
     */
    gateWayName: number
    /**
     * 采样频率
     */
    mhfHz: string
    /**
     * 波形点数
     */
    wavePoint: number
    /**
     * 传感器id
     */
    id: string
    /**
     * VB50sim卡号
     */
    mqttSim?: string

    /**
     * 波形采样频率，下发状态
     */
    sendWaveStatus: E_SendWaveStatus

    /**
     * 寄存器开始地址
     */
    tempStorageStart?: number

    /**
     * 寄存器结束地址
     */
    tempStorageEnd?: number

    /**
     * 
     */
    unbindSensorStatus?: E_UnbindSensorStatus

    /**
     * 长休眠
     */
    longSleep?: E_YesNoNumber

    /**
     * 3轴包络阈值上限：x,y,z
     */
    envelopeMax: string

    /**
     * 3轴包络阈值下限：x,y,z
     */
    envelopeMin: string

    /**
     * 3轴振动烈度上限：x,y,z
     */
    vibraMax: string

    /**
     * 波形采集加速度 阈值下限
     */
    waveAccMin: string

    /**
     * 高频Z轴加速度上限
     */
    ahighMax: number

    /**
     * 加速度校准系数: X3,X2,X1,B
     */
    accCompensate: string
    accCompensateStatus: E_CompensateStatus
    accHighCompensateStatus: E_CompensateStatus

    /**
     * 电流量程
     */
    elecRange: string

    /**
     * 交流三相电流系数:X1,X0,B
     */
    elecCompensate: string

    /**
     * 高频灵敏度校准系数
     */
    sensitivityHighCompensate: string

    /**
     * 网关id
     */
    gatewaySn: string

    /**
     * 网关id锁定
     */
    gatewaySnLock: E_GatewaySnLock

    /**
     * 广域网络id
     */
    wanId: string

    offlineDataStatus: E_OfflineDataStatus

    /**
     * 同步采集状态
     */
    syncCollectStatus?: E_SyncCollectStatus

    /**
     * 采集模型
     */
    dataSamplingMode?: E_DataSamplingMode
}

export interface ISensorUpload extends ISensorInfoBase {
    /**
     * AD采集频率
     */
    collFrequency?: number

    /**
     * 通信选择
     */
    commChoice: E_CommChoice


    cardChannelId: number

    /**
     * 采集卡id
     */
    cardId?: number

    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 采样倍数
     */
    samplingMultiple: number

    longSleep?: E_YesNoNumber

    tempStorageStart?: number
    tempStorageEnd?: number

    dataSamplingMode?: E_DataSamplingMode
}

export interface ISensorInfoBase {
    /**
     * 采集卡通道id
     */
    cardChannelId?: number

    /**
     * 通信选择
     */
    commChoice: E_CommChoice

    /**
     * 采集卡id
     */
    cardId?: number

    /**
     * 标记名
     */
    tagName: E_XYGT_TagName
    /**
     * 报警时是否采集
     */
    alarmCollect: E_YesNoNumber
    /**
     * 报警间隔
     * 单位(分钟)
     */
    alarmInterval: number
    /**
     * 区域id
     */
    areaId?: number
    /**
     * 采集模型
     */
    collectMode: E_CollectMode
    /**
     * 采集间隔
     */
    collectSpace: number
    /**
     * 每天采集时间
     */
    collectTime: number
    /**
     * 工作方式
     */
    collectWork: E_CollectWork
    /**
     * 公司id
     */
    companyId: number
    /**
     * VB24H特征值上传数
     */
    dataCount: number
    /**
     * VB24H特征值采样时间
     */
    dataSampling: number
    /**
     * VB24H特征值上传时间
     */
    dataUpload: number
    /**
     * 设备id
     */
    equipmentId?: number
    /**
     * 网关ID
     */
    gatewayId?: number
    /**
     * VB24H硬件版本号
     */
    hardwareVersion: number

    /**
     * 安装方式
     */
    installMode: E_InstallMethod
    /**
     * 启用故障自诊断
     */
    isFault: E_YesNoNumber
    /**
     * VB24H侦听时长
     */
    listening: number
    /**
     * mac地址
     */
    mac: string
    /**
     * 测点ID
     */
    mappingId?: number
    /**
     * 传感器名称
     */
    name: number
    /**
     * VB24H启用波形采集，1开启，2关闭
     */
    openWave: E_SensorOpenWave
    /**
     * 传感器配置详情
     */
    sensorSetList: ISensorSetListItem[]
    /**
     * VB24H传感器类型
     */
    sensorType: E_SensorType
    /**
     * VB24H信号强度
     */
    signalHeart: number
    /**
     * 休眠时间
     */
    sleepT: number
    /**
     * VB24H软件版本号
     */
    softwareVersion: string
    /**
     * 传感器类型
     */
    type: E_SensorKlass
    /**
     * VB24H上传率
     */
    uploadRate: string
    /**
     * VB24H无限通道
     */
    wirelessChannel?: number
    /**
     * VB24H无线频段
     */
    wirelessFrequency?: string

    /**
     * 传感器灵敏度
     */
    sensorSensitivity: number
    /**
     * 偏置电压
     */
    voltage: number

    /**
     * 1:水平，2：径向，3：垂直
     */
    x1: E_SensorDirection
    y1: E_SensorDirection
    z1: E_SensorDirection

    /**
     * VB50密码
     */
    mqttPassword?: string
    /**
     * VB50IP地址
     */
    mqttServerIp?: string
    /**
     * VB50端口号
     */
    mqttServerPort?: string
    /**
     * VB50用户名
     */
    mqttUserName?: string

    /**
     * 转标准协议
     */
    convertProtocolType?: E_ConvertProtocolType

    /**
     * 波形压缩功能开关
     */
    waveCompressFlag?: E_WaveCompressFlag
    
    /**
     * 通信协议类型
     */
    communicationProtocolType?: E_CommunicationProtocolType

    /**
     * 协议版本
     */
    protocolVer?: E_ProtocolVersion

    /**
     * APN名称
     */
    apnName?: string
    /**
     * APN用户名
     */
    apnUserName?: string
    /**
     * APN密码
     */
    apnPassword?: string
    /**
     * TCP服务器地址或域名
     */
    tcpServerIp?: string
    /**
     * TCP服务器端口号
     */
    tcpServerPort?: string
    /**
     * MQTT主题前缀
     */
    mqttTopicPrefix?: string

    /**
     * 高频波形补偿系数
     */
    accHighCompensate?: string

    /**
     * 安装方向自适应
     */
    installAxialAdaption?: E_YesNoNumber

    /**
     * 同步采集状态
     */
    syncCollectStatus?: E_SyncCollectStatus
}

export interface IAlarmTypeVOData {
    /**
     * 有效报警间隔次数，超过几次才报警
     */
    effectiveIntervalCount: number
    // /**
    //  * 有效报警间隔时间，分钟
    //  */
    // effectiveIntervalTime: number
    /**
     * 报警间隔次数，超过几次不报警
     */
    intervalCount: number
    /**
     * 报警间隔时间，分钟
     */
    intervalTime: number
}

export interface IAlarmTypeVO extends IAlarmTypeVOData {
    /**
     * 报警类型
     */
    alarmType: E_AlarmType
    /**
     * 勾选状态
     */
    status: E_SelectedStatus
}


export type ISensorAddPointMappingParams = IPointMapping & ICoordinate


export type ISensorAddSensorParams = ISensorUpload

export interface ISensorAddSensorAlarmParams {
    /**
     * 报警阈值映射id
     */
    alarmThresholdId: number
    /**
     * 启用故障自诊断
     */
    isFault: E_YesNoNumber
    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 报警类型配置选择
     */
    alarmTypeVOS: IAlarmTypeVO[]

    /**
     * VB24H中频Z轴启停
     */
    lowZSs: number
    /**
     * VB24H高频Z轴启停
     */
    highZSs: number

}

export interface ISensorAddSensorLearnParams {
    isUse: E_UseLearn
    /**
     * ai自学习结束时间
     */
    learnEndTime: string
    /**
     * ai自学习开始时间
     */
    learnStartTime: string
    /**
     * 启动ai自学习
     */
    openLearn: E_StartStatus
    /**
     * 测点ID
     */
    mappingId: number
    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 传感器学习id
     */
    sensorLearnId: number
}



export interface ISensorCheckPasswordParams {
    checkPassword: string
}

export interface ISensorCopyFaultSettingBySensorIdParams {
    /**
     * 传感器编号-被复制传感器
     */
    oldSensorId: string
    /**
     * 复制到传感器编号
     */
    sensorIds: string[]
}

export interface ISensorDelMappingParams {
    id: number
}
export type ISensorEditFaultParams = IFaultSetting

export interface ISensorGetPointMappingDetailParams {
    id: number
}

export interface ISensorGetPointMappingDetailData extends IPointMapping, ICoordinate {
    /**
     * 采样倍数
     */
    samplingMultiple: number
    /**
     * 采集卡通道id
     */
    cardChannelId?: number

    /**
     * 通信选择
     */
    commChoice: E_CommChoice

    /**
     * 采集卡id
     */
    cardId?: number
    /**
     * 部件关联id
     */
    componentId: number

    /**
     * 传感器id
     */
    sensorId?: string

    /**
     * 图片地址
     */
    fileList: IFileListItem[]
    /**
     * 第一张图
     */
    defaultFile: IFileListItem
    id: number

}

export interface ISensorGetSensorAlarmDetailParams {
    sensorId: string
}

export interface ISensorGetSensorAlarmDetailData extends ISensorAddSensorAlarmParams {
    /**
     * 传感器id
     */
    id: number
    /**
     * 启动ai自学习
     */
    openLearn: E_StartStatus
    /**
     * 阈值名称
     */
    alarmThresholdName: string
}

export interface ISensorGetSensorDetailParams {
    sensorId: string
}

export type ISensorGetSensorDetailData = ISensorInfo

export interface ISensorGetSensorLearnDetailParams {
    sensorId: string
}
export interface ISensorGetSensorLearnDetailData {
    /**
     * 传感器id
     */
    id: string
    /**
     * ai自学习结束时间
     */
    learnEndTime: string
    /**
     * ai自学习开始时间
     */
    learnStartTime: string
    /**
     * 启动ai自学习
     */
    openLearn: E_StartStatus
}

export type ISensorPointPageListParams = IPageParams & Partial<{
    companyId: number
    areaId: number
    equipmentId: number
    sensorId: string
    isOnline: E_OnlineOffline
    /*
    */
    isFault: number
    sensorType: E_SensorKlass
}>

export interface ISensorPointPageListItem {

    /**
     * 信号强度
     */
    signalHeart: number

    commChoice: E_CommChoice

    cardChannelId: number
    channelName: string

    cardId: number
    cardName: string
    channelType: E_ChannelType

    gatewayId: number
    gatewayName: string


    /**
     * 区域id
     */
    areaId: string
    /**
     * 是否绑定报警灯
     */
    bindLamp: number
    /**
     * 
     */
    collectMode: E_CollectMode
    /**
     * 公司/区域名称
     */
    companyAreaName: string
    /**
     * 
     */
    companyId: string
    /**
     * 
     */
    equipmentId: string
    /**
     * 
     */
    equipmentName: string
    /**
     * 测点id
     */
    id: number
    /**
     * 测点名称
     */
    pointName: string
    /**
     * 
     */
    sensorId: string
    /**
     * 传感器名称
     */
    sensorName: string
    /**
     * 传感器编号
     */
    sensorType: string
    /**
     * 阈值名称
     */
    thresholdName: string
    /**
     * 电池电量
     */
    battery: number
    /**
     * 在线状态
     */
    isOnline: E_OnlineOffline
    /**
     * 最后上线时间
     */
    lastTime: string

    isFault: E_FaultStatus
}

export type ISensorPointPageListData = IPageData<ISensorPointPageListItem>

export interface ISensorQueryFaultSettingBySensorIdParams {
    sensorId: string
}

export interface ISensorQueryFaultSettingBySensorIdData extends IFaultSetting {

}

export interface ISensorUnbindSensorParams {
    id: number
}


export interface ISensorUpdatePointMappingParams extends IPointMapping {
    /**
     * 测点id
     */
    id: number
    /**
     * 修改前部件关联id
     */
    oldComponentId: number
}


export interface ISensorUpdateSensorParams {
    oldSensorId?: string
    /**
     * JJ调试
     */
    jjDebug?: E_JJDebug
    /**
     * 传感器调试参数
     */
    sensorDebug?: Partial<ISensorDebug>
}

export interface ISensorUploadFileParams {
    fileIdArray: number[]
    id: number
}

export interface ISensorMqttReadInfoParams {
    sensorId: string
}

export interface ISensorMqttReadSimParams {
    sensorId: string
}

export interface ISensorLoRoInfoBase {
    /**
     * 传感器密钥
     */
    aesKey: string
    /**
     * 接收频率
     */
    receiveFreq: number
    /**
     * 接收扩频因子
     */
    receiveSpsp: number
    /**
     * 发射频率
     */
    sendFreq: number
    /**
     * 发射扩频因子
     */
    sendSpsp: number
    /**
     * 传感器id
     */
    sensorId: string
}

export type ISensorSettingLoRaInfoParams = ISensorLoRoInfoBase

export interface ISensorLoRoInfo extends ISensorLoRoInfoBase {

    id: number
    /**
     * 接收载波反转
     */
    receiveCarrierReversal: E_CarrierReversal

    /**
     * 发送载波反转
     */
    sendCarrierReversal: E_CarrierReversal
}


export interface ISensorGetLoRaInfoParams {
    sensorId: string
}

export type ISensorGetLoRaInfoData = ISensorLoRoInfo

export interface ISensorGetParamsParams {
    sensorId: string
}

export interface ISensorGetParamsData {
    /**
     * 硬件版本
     */
    hardwareVersion: string
    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 软件版本
     */
    softwareVersion: string

    /**
     * 信号强度
     */
    signalHeart: string
}

export interface ISensorReadSensorVersionParams {
    sensorId: string
}

export interface ISensorReadSensorLoraParams {
    sensorId: string
}

export interface ISensorReadSensorSignalParams {
    sensorId: string
}

export interface ISensorSettingDateTimeParams {
    sensorId: string
}

export interface ISensorSettingWirelessChannelParams {
    sensorId: string
    /**
     * VB24H无限通道
     */
    wirelessChannel: number
    /**
     * VB24H无线频段 
     */
    wirelessFrequency: string
}

export interface ISensorSettingAccHighCompensateParams {
    sensorId: string
}

export interface ISensorBatchAccHighCompensateParams {
    sensorIds: string[]
}

export interface ISensorBatchSettingSensorDateTimeParams {
    sensorIds: string[]
}

export interface ISensorBatchUpdateSensorParams extends Partial<ISensorDebug> {
    /**
     * 勾选修改的参数名。通用协议仅更新并下发这些字段。
     */
    selectedFields: string[]

    /**
     * 调试参数。selectedFields 使用该对象内部的字段名，
     * 例如 gatewaySn、accCompensate，不添加 sensorDebug 前缀。
     */
    sensorDebug?: Partial<ISensorDebug>

    /**
     * 传感器 IDs
     */
    sensorIds: string[]

    /**
    * 报警时是否采集
    */
    alarmCollect?: E_YesNoNumber

    /**
    * AD采集频率
    */
    collFrequency?: number
    /**
     * 采集模型
     */
    collectMode?: E_CollectMode

    /**
     * 采集间隔
     */
    collectSpace?: number
    /**
     * 每天采集时间
     */
    collectTime?: number

    /**
     * VB24H特征值采样时间
     */
    dataSampling?: number
    /**
     * VB24H特征值上传时间
     */
    dataUpload?: number

    /**
     * 安装方向自适应
     */
    installAxialAdaption?: E_YesNoNumber

    /**
     * 安装方式
     */
    installMode?: E_InstallMethod

    /**
     * 监听周期
     */
    listening?: number

    /**
     * VB24H启用波形采集，1开启，2关闭
     */
    openWave?: E_SensorOpenWave

    /**
     * 采样倍数
     */
    samplingMultiple?: number
    /**
     * 传感器配置详情
     */
    sensorSetList?: ISensorSetListItem[]

    sensorType?: string
    sensorSensitivity?: number
    sleepT?: number
    voltage?: number
    /**
    * 1:水平，2：径向，3：垂直
    */
    x1?: E_SensorDirection
    y1?: E_SensorDirection
    z1?: E_SensorDirection

    longSleep?: E_YesNoNumber

    /** 协议版本：0 旧版协议，1 通用协议 */
    protocolVer?: E_ProtocolVersion

    /** 采集模式 */
    dataSamplingMode?: E_DataSamplingMode

    /** APN 配置 */
    apnName?: string
    apnUserName?: string
    apnPassword?: string

    /** TCP/MQTT 通信配置 */
    communicationProtocolType?: E_CommunicationProtocolType
    tcpServerIp?: string
    tcpServerPort?: string
    mqttServerIp?: string
    mqttServerPort?: string
    mqttUserName?: string
    mqttPassword?: string
    mqttTopicPrefix?: string

    /** 同步采集状态 */
    syncCollectStatus?: E_SyncCollectStatus

    /** 波形压缩功能开关 */
    waveCompressFlag?: E_WaveCompressFlag

    /** 中频波形参数 */
    mediumInterval?: number
    mediumHz?: string
    mediumPoint?: string
    mediumAxis?: string

    /** 高频波形参数 */
    highInterval?: number
    highHz?: string
    highPoint?: string
    highAxis?: string

    /** 高频长波形参数 */
    highLongInterval?: number
    highLongHz?: string
    highLongPoint?: string
    highLongAxis?: string

    /** 声纹参数 */
    voiceprintInterval?: number
    voiceprintTime?: number
}

export interface ISensorBindSensorParams {
    mappingId: number
    sensorId: string
}

export interface ISensorDelSensorByIdParams {
    id: string
}

export interface ISensorBatchDeleteParams {
    /** 传感器 ID，后端限制最多 200 个 */
    sensorIds: string[]
}

export type T_SensorBatchDeleteResult = 'SUCCESS' | 'SKIPPED' | 'FAILED'

export interface ISensorBatchDeleteResultItem {
    sensorId: string
    result: T_SensorBatchDeleteResult
    message: string
}

export interface ISensorBatchDeleteData {
    totalCount: number
    successCount: number
    skipCount: number
    failCount: number
    items: ISensorBatchDeleteResultItem[]
}

export interface ISensorGetSensorInfoParams {
    sensorId: string
}

export interface ISensorGetSensorInfoData {
    companyName: string
    id: string
    parentCompanyName: string
    userName: string
}

export interface ISensorGetSensorConfigStatusParams {
    sensorId: string
}

export interface ISensorGetSensorConfigStatusData {
    /**
     * 电流量程
     */
    elecRange: string

    /**
     * 交流三相电流系数:X1,X0,B
     */
    elecCompensate: string


    /**
     * 更新时间
     */
    updateTime: string
    /**
     * 加速度校准系数: X3,X2,X1,B
     */
    accCompensate: string
    /**
     * 加速度校准系数开关
     */
    accCompensateStatus: E_CompensateStatus
    /**
     * 高频波形补偿系数: X3,X2,X1,B
     */
    accHighCompensate: string
    /**
     * 高频加速度校准系数开关
     */
    accHighCompensateStatus: E_CompensateStatus
    ahighMax: number
    /**
     * 蓝牙名称
     */
    bluetoothName: string
    /**
     * 特征值采样时间
     */
    dataSampling: number
    /**
     * 采集模式
     */
    dataSamplingMode: E_DataSamplingMode
    /**
     * 特征值上传时间
     */
    dataUpload: number
    /**
     * 3轴包络阈值上限：[x,y,z]
     */
    envelopeMax: string
    /**
     * 3轴包络阈值下限：[x,y,z]
     */
    envelopeMin: string
    /**
     * 网关id
     */
    gatewaySn: string
    /**
     * 网关id锁定
     */
    gatewaySnLock: E_GatewaySnLock
    /**
     * 高频轴向
     */
    highAxis: string
    /**
     * 高频采样频率
     */
    highHz: string
    /**
     * 高频上传周期
     */
    highInterval: number
    /**
     * 高频长波形轴向
     */
    highLongAxis: string
    /**
     * 高频长波形采样频率
     */
    highLongHz: string
    /**
     * 高频长波形上传周期
     */
    highLongInterval: number
    /**
     * 高频长波形采样点数
     */
    highLongPoint: string
    /**
     * 高频采样点数
     */
    highPoint: string
    /**
     * 中频轴向
     */
    mediumAxis: string
    /**
     * 中频采样频率
     */
    mediumHz: string
    /**
     * 中频上传周期
     */
    mediumInterval: number
    /**
     * 中频采样点数
     */
    mediumPoint: string
    /**
     * 离线数据状态
     */
    offlineDataStatus: E_OfflineDataStatus
    /**
     * 高频灵敏度校准系数
     */
    sensitivityHighCompensate: string
    /**
     * 传感器id
     */
    sensorId: string
    /**
     * 传感器参数修改次数
     */
    settingNum: number
    /**
     * 同步采集状态
     */
    syncCollectStatus: E_SyncCollectStatus
    /**
     * 3轴振动烈度上限：[x,y,z]
     */
    vibraMax: string
    /**
     * 声纹上传周期
     */
    voiceprintInterval: number
    /**
     * 声纹采集时长-秒
     */
    voiceprintTime: number
    /**
     * 广域网络id
     */
    wanId: number
    /**
     * 波形采集加速度 阈值下限
     */
    waveAccMin: number
    /**
     * 射频通道
     */
    wirelessChannel: number

    simIccis: string

    apnName: string

    apnPassword: string

    apnUserName: string

    communicationProtocolType: E_CommunicationProtocolType

    mqttPassword: string

    mqttServerIp: string

    mqttServerPort: string

    mqttUserName: string

    waveCompressFlag: E_WaveCompressFlag
    /**
     * TCP服务器地址或域名
     */
    tcpServerIp?: string
    /**
     * TCP服务器端口号
     */
    tcpServerPort?: string
    /**
     * MQTT主题前缀
     */
    mqttTopicPrefix?: string

}

export type ISensorPageListParams = IPageParams & Partial<{
    gatewayName: string
    sensorId: string
    sensorType: string
    sleepT: number
    unbindSensorStatus: E_UnbindSensorStatus
}>

export interface ISensorPageListItem {
    battery
    createTime
    dataSampling
    dataUpload
    gatewayId
    gatewayName
    id
    lastCollectTime
    lastTime
    mappingId
    sensorName
    sensorType
    signalHeart
    sleepT
    unbindSensorStatus: E_UnbindSensorStatus
    vibrationIntensity
    vx
    vy
    vz
    protocolVer: E_ProtocolVersion
    /**
     * 软件版本号
     */
    softwareVersion?: string
    /** 固件升级状态，0 表示无升级任务 */
    upgradeStatus?: E_FirewareUpgradeStatus | 0
    /** 固件升级进度（0-100） */
    upgradeProgress?: number
}

export type ISensorPageListData = IPageData<ISensorPageListItem>

export interface ISensorImportFileParams {
    file: File
}

export interface ISensorImportFileData {
    errorCount
    errorExcelData
    errorFileName
    importStatus: E_ImportStatus
}

export interface ISensorExportParams {
    gatewayName
    sensorId
    sensorType
    sleepT
    unbindSensorStatus: E_UnbindSensorStatus
}

export interface ISensorSettingParams {
    b: string
    coefType: E_CoefType
    sensorId: string
    x1: string
    x2: string
    x3: string
}

export interface ISensorSetSettingAccHighCompensateParams extends ISensorSettingParams {

}

export interface ISensorGetSettingAccHighCompensateParams {
    sensorId: string
}

export interface ISensorGetSettingAccHighCompensateData extends ISensorSettingParams {
    status: E_SensorDownloadStatus
}

export interface ISensorFactoryResetParams {
    sensorId: string
}

export interface ISensorRestartParams {
    sensorId: string
}

export interface ISensorTerminalParams {
    sensorId: string
    cmd: string
}

export interface ISensorQuerySendSettingStatusByTypeParams {
    sensorId: string
    settingType: E_SensorSettingType
}

export interface ISensorQuerySendSettingStatusByTypeData {
    sensorId: string
    status: E_SendWaveStatus
}
